import { useState } from "react";
import { useTranslation } from "react-i18next";

import { AiAssistantJSONChatMessageType } from "types/aiAssistant";
import { useAiAssistant } from "hooks/useAiAssistant";

import { IAiAssistantSuggestedActionConfig } from "../types";

export const useAiAssistantModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { chatHistory, handleSendMessage, isLoading, handleNewChat } = useAiAssistant();

  const handleChangeModal = (value?: boolean) => {
    setIsOpen(value ?? !isOpen);
  };

  const handleSuggestedActionClick = (action: IAiAssistantSuggestedActionConfig) => {
    const translatedText = t(action.textKey);
    handleSendMessage(translatedText);
  };

  const handleSubmitButtonClick = (actionType: AiAssistantJSONChatMessageType) => {
    if (actionType === AiAssistantJSONChatMessageType.SUBMIT_PAYROLL) {
      handleSendMessage("Yes, the data is correct, submit the payroll");
    } else if (actionType === AiAssistantJSONChatMessageType.INCREASE_HOURLY_RATE) {
      handleSendMessage("Yes, the data is correct, increase the hourly rate");
    } else if (actionType === AiAssistantJSONChatMessageType.CREATE_EMPLOYEE) {
      handleSendMessage("Yes, the data is correct, create the employee");
    }
  };

  const handleCancelButtonClick = () => {
    handleSendMessage("No, abort the action");
  };

  return {
    isOpen,
    handleChangeModal,
    chatHistory,
    isLoading,
    handleSendMessage,
    handleSuggestedActionClick,
    handleNewChat,
    handleSubmitButtonClick,
    handleCancelButtonClick,
  };
};
